import types from '@/store/types/DetalleInclusionExclusion'
import Vue from 'vue';

const state = {
  lstInclusionExclusion: [],
  datosInclusionExclusionNet:[],
  datosInclusionExclusionPromocionNet:[],

}
const getters = {
  [types.getters.GetlstInclusionExclusion]:(state) => {
      return state.lstInclusionExclusion;
  },
  [types.getters.GetdatosInclusionExclusionNet]:(state) => {
    return state.datosInclusionExclusionNet;
  },

  [types.getters.GetdatosInclusionExclusionPromocion]:(state) => {
    return state.datosInclusionExclusionPromocionNet;
  }
}
const mutations = {
  [types.mutations.SetlstInclusionExclusion]:(state, lst) => {
    state.lstInclusionExclusion = lst;
  },
  [types.mutations.SetdatosInclusionExclusionNet]:(state, lst) => {
    state.datosInclusionExclusionNet = lst;
  },



  [types.mutations.SetdatosInclusionExclusionPromocion]:(state, lst) => {
    state.datosInclusionExclusionPromocionNet = lst;
  },



}
const actions = {
  [types.actions.RegistrarInclusionExclusion]:({commit}, pObj) => {
      return new Promise ((resolve,reject)=>{
          Vue.prototype.$http.post(`pajel/detalle_inclusion_exclusion/add`,pObj).then(r => {
                resolve(r);
          })
      })
  },
  [types.actions.ModificarInclusionExclusion]:({commit}, pObj) => {
      return new Promise ((resolve,reject)=>{
          Vue.prototype.$http.put(`pajel/detalle_inclusion_exclusion/update/${pObj.detalleInclusionExclusionId}`, pObj).then(r=>{
              resolve(r);
          })
      })
  },
  [types.actions.EliminarInclusionExclusion]:({commit}, pDetalleInclusionExclusionId) => {
    return new Promise ((resolve,reject)=>{
        Vue.prototype.$http.delete(`pajel/detalle_inclusion_exclusion/delete/${pDetalleInclusionExclusionId}`).then(r=>{
            resolve(r);
        })
    })
  },
  [types.actions.ObtenerInclusionExclusion]:({commit}, pObj)=> {
      return new Promise ((resolve,reject)=>{
        Vue.prototype.$http.get(`pajel/detalle_inclusion_exclusion/list/${pObj.ampliacionId}/${pObj.promocionEmpresarialNetId}/${pObj.tipoInclusionExclusionId}`).then(r => {
            commit(types.mutations.SetlstInclusionExclusion,r.data)
              resolve(r);
            });
      })
  },
  [types.actions.EnviarInclusionExclusionSolicitud]:({commit},pObj)=>{
    return new Promise ((resolve,reject)=>{
      Vue.prototype.$http.post(`pajel/ampliacion/net/inclusion_exclusion/enviar_solicitud`, pObj)
        .then(r => {
          resolve(r);
        });
    });
  },
  //Net
  [types.actions.ObtenerInclusionExclusionNet]:({commit},personaId)=>{
    return new Promise ((resolve,reject)=>{
      Vue.prototype.$http.get(`pajel/detalle_inclusion_exclusion/net/list/${personaId}`).then(r => {
          commit(types.mutations.SetdatosInclusionExclusionNet,r.data)
            resolve(r);
          });
    })
  },
  //net pajel3
  [types.actions.ObtenerInclusionExclusionSolicitudesNet]:({commit},obj)=>{
    return new Promise ((resolve,reject)=>{
      //Vue.prototype.$http.get(`pajel/detalle_inclusion_exclusion/net/list/${personaId}`).then(r => {
      //Vue.prototype.$http.get(`pajel/detalle_inclusion_exclusion/solicitudesEnviadasNet/${personaId}`).then(r => {
      Vue.prototype.$http.get(`pajel/solicitud/eviadasNet/${obj.codTramite}/${obj.personaId}`).then(r => {
          commit(types.mutations.SetdatosInclusionExclusionNet,r.data)
            resolve(r);
          });
    })
  },
  [types.actions.ObtenerInclusionExclusionPromocionesNet]:({commit},obj)=>{
    return new Promise ((resolve,reject)=>{
      //Vue.prototype.$http.get(`pajel/detalle_inclusion_exclusion/promocionesEmpresarialesNet/${personaId}`).then(r => {
      Vue.prototype.$http.get(`pajel/promocion_empresarial/promocionesEmpresarialesNet/${obj.codTramite}/${obj.personaId}`).then(r => {
          commit(types.mutations.SetdatosInclusionExclusionPromocion,r.data)
            resolve(r);
          });
    })
  },

  //aun no se utiliza
  [types.actions.ObtenerInclusionExclusionxDetalleInclusionExclusionId]:({commit},pDetalleInclusionExclusionId)=>{
    return new Promise ((resolve,reject)=>{
      Vue.prototype.$http.get(`pajel/detalle_inclusion_exclusion/find/${pDetalleInclusionExclusionId}`).then(r => {
          commit(types.mutations.SetdatosInclusionExclusionNet,r.data)
            resolve(r);
          });
    })
  }



}
export default {
  state,
  actions,
  getters,
  mutations
}
